import {
  Badge as AriesBadge,
  Flex as AriesFlex,
  Greyscale,
  ScreenSize,
} from 'glints-aries';
import styled from 'styled-components';

import UnstyledButton from 'src/components/Button/UnstyledButton';
import GlintsContainer from 'src/components/GlintsContainer';
import { scrollToTopButtonZIndex } from 'src/components/ScrollTopButton/ScrollTopButton.sc';
import { borderColor } from 'src/modules/Opportunities/pages/Explore/Components/FilterSection/styles.sc';

import { JOB_TAB_Z_INDEX } from '../../../../../components/JobTabNavigation/styles.sc';

const VerticalGapBetweenStickyFilterAndContainer = 24;

export const QueryExploreTabBody = styled(GlintsContainer)<{
  isJobTabShown: boolean;
}>`
  @media (min-width: ${ScreenSize.desktopS}px) {
    padding-top: ${({ isJobTabShown }) => (isJobTabShown ? 16 : 24)}px;
  }
`;

export const MobileStickySearchAndFilterContainer = styled.div<{
  topTabBarHeight: number;
  isSearchModalOpen: boolean;
}>`
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  padding: 0 15px;
  position: sticky;
  top: ${({ topTabBarHeight }) => topTabBarHeight + 1}px;
  z-index: ${({ isSearchModalOpen }) =>
    isSearchModalOpen ? scrollToTopButtonZIndex + 1 : JOB_TAB_Z_INDEX - 1};
  height: 103px;
  background-color: ${Greyscale.white};
`;

export const MobileFilterButton = styled(UnstyledButton)`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 4px;
  padding-bottom: 4px;
  border: solid 1px rgba(198, 198, 198, 0.6);
  border-radius: 14.5px;
  color: ${Greyscale.grey};
  font-weight: normal;
`;

export const MobileFilterButtonBadge = styled(AriesBadge).attrs({
  variant: 'dimmed',
})`
  .badge-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const DesktopSearchBoxWrapper = styled.div`
  display: block;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${ScreenSize.desktopS}px) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const DesktopStickyFilterContainer = styled.div<{
  topTabBarHeight: number;
}>`
  display: none;

  @media (min-width: ${ScreenSize.desktopS}px) {
    position: sticky;
    top: ${({ topTabBarHeight }) =>
      topTabBarHeight + VerticalGapBetweenStickyFilterAndContainer}px;
    z-index: 1;
    display: block;
    min-width: 316px;
    max-height: ${({ topTabBarHeight }) =>
      `calc(100vh - ${
        topTabBarHeight + VerticalGapBetweenStickyFilterAndContainer * 2
      }px)`};
    margin-right: 32px;
    overflow-y: auto;
  }
`;

export const FilterContainerBorder = styled.div`
  border: solid 1px ${borderColor};
  border-radius: 4px;
`;

export const Flex = styled(AriesFlex).attrs({ flexDirection: 'column' })`
  width: 100%;
  align-items: center;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;

export const RetryButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px 0;
`;

export const Heading = styled.h1`
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 500;

  @media (min-width: ${ScreenSize.desktopS}px) {
    font-size: 18px;
  }
`;
